import { PureComponent, type ReactElement } from "react";

import { LoadingSpinner } from "widgets";

import { type ParentType } from "../../graphql.js";
import AddParentTypeDialog, { type IAddParentTypeDialogProps } from "./AddParentTypeDialog.js";

export interface IModifyParentTypeDialogProps extends IAddParentTypeDialogProps {
  fetchFullParentTypeWithAttributes: (parentTypeId: number) => Promise<ParentType>;
}

interface IModifyParentTypeDialogState {
  isLoadingParentType?: boolean;
  parentType?: ParentType;
}

// component that takes the responsibiltiy of loading all the extended properties and attributes of the parent type to be edited
class ModifyParentTypeDialog extends PureComponent<IModifyParentTypeDialogProps, IModifyParentTypeDialogState> {
  constructor(props) {
    super(props);

    this.state = {
      isLoadingParentType: false,
      parentType: null,
    };
  }

  componentDidMount() {
    this.setState({ isLoadingParentType: true });
    this.props.fetchFullParentTypeWithAttributes(this.props.parentType.id).then((parentType: ParentType) => {
      this.setState({
        parentType: parentType,
        isLoadingParentType: false,
      });
    });
  }

  render(): ReactElement {
    return this.state.isLoadingParentType ? (
      <LoadingSpinner inCenter />
    ) : (
      <AddParentTypeDialog {...this.props} parentType={this.state.parentType} />
    );
  }
}

export default ModifyParentTypeDialog;
